import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomInput from '@acnb/CustomComponents/CustomInput/CustomInput';

const ViewListSearchBar = ({ isLoading, tableDataParams, setTableDataParams }) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState(tableDataParams.search || '');

  useEffect(() => {
    setSearchValue(tableDataParams.search || '');
  }, [tableDataParams.search]);

  const applySearchValue = useCallback(
    value => {
      if (value !== tableDataParams.search) {
        setTableDataParams({ ...tableDataParams, search: value, currentPage: 1 });
      }
    },
    [setTableDataParams, tableDataParams],
  );

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      applySearchValue(event.target.value);
    }
  };

  return (
    <CustomInput
      labelText={t('search')}
      id="search"
      hasSkeleton
      isLoading={isLoading}
      formControlProps={{
        style: { maxWidth: '40vh', width: '100%' },
      }}
      inputProps={{
        value: searchValue,
        onChange: ({ target: { value } }) => setSearchValue(value),
        onBlur: ({ target: { value } }) => {
          applySearchValue(value);
        },
        onKeyDown: handleKeyDown,
      }}
    />
  );
};

export default ViewListSearchBar;
